module.exports = __webpack_public_path__ + "static/media/beauty-1.83bc7cbc.svg";